import { IPhanPhoiDeThi } from "../../../model/respone/de-thi/IPhanPhoiDeThi";
import { IPhanPhoiDeThiActionTypes } from "../../action-types/de-thi/IPhanPhoiDeThiActions";
import { IPhanPhoiDeThiReducer } from "../../reducer-model/de-thi/IPhanPhoiDeThiReducer";

import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IPhanPhoiDeThiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    statusHistory: eReducerStatusBase.is_not_initialization,
    idSelections: [],
    phanPhoiEditing: {} as IPhanPhoiDeThi,
    thuHoiEditing: {} as IPhanPhoiDeThi,
    deThiTrongKhoTongs: [],
    deThiDaPhanPhois: [],
    phanPhoiHistorys: [],
    request: {
        id_mon: 0,
        id_he: 0,
        id_nhomdethiin: 0,
        id_chude: 0,
        id_he_phan_phoi: 0,
    } as any,
};

export const phanPhoiDeThiReducer = (
    state: IPhanPhoiDeThiReducer = iniState,
    action: IPhanPhoiDeThiActionTypes
): IPhanPhoiDeThiReducer => {
    switch (action.type) {
        case "PHAN_PHOI_DE_THI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "PHAN_PHOI_DE_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                deThiTrongKhoTongs: action.payload.trongKhoTong,
                deThiDaPhanPhois: action.payload.daPhanPhoi,
            };
        case "PHAN_PHOI_DE_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "PHAN_PHOI_DE_THI_PHAN_PHOI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "PHAN_PHOI_DE_THI_PHAN_PHOI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                phanPhoiEditing: undefined,
                isShowPhanPhoiModal: false,
            };
        case "PHAN_PHOI_DE_THI_PHAN_PHOI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "PHAN_PHOI_DE_THI_THU_HOI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "PHAN_PHOI_DE_THI_THU_HOI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                thuHoiEditing: undefined,
                isShowThuHoiModal: false,
            };
        case "PHAN_PHOI_DE_THI_THU_HOI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "PHAN_PHOI_DE_THI_SHOW_PHAN_PHOI_MODAL":
            return {
                ...state,
                phanPhoiEditing: action.payload,
                isShowPhanPhoiModal: true,
            };
        case "PHAN_PHOI_DE_THI_CLOSE_PHAN_PHOI_MODAL":
            return {
                ...state,
                phanPhoiEditing: undefined,
                isShowPhanPhoiModal: false,
            };
        case "PHAN_PHOI_DE_THI_SHOW_THU_HOI_MODAL":
            return {
                ...state,
                thuHoiEditing: action.payload,
                isShowThuHoiModal: true,
            };
        case "PHAN_PHOI_DE_THI_CLOSE_THU_HOI_MODAL":
            return {
                ...state,
                thuHoiEditing: undefined,
                isShowThuHoiModal: false,
            };
        case "PHAN_PHOI_DE_THI_CHANGE_REQUEST":
            return {
                ...state,
                request: {
                    ...state.request,
                    ...action.payload,
                },
            };
        case "PHAN_PHOI_DE_THI_SELECTED_ID":
            return {
                ...state,
                idSelections: action.payload,
            };
        case "PHAN_PHOI_DE_THI_LOAD_HISTORY_START":
            return {
                ...state,
                statusHistory: eReducerStatusBase.is_loading,
            };
        case "PHAN_PHOI_DE_THI_LOAD_HISTORY_SUCCESS":
            return {
                ...state,
                statusHistory: eReducerStatusBase.is_completed,
                phanPhoiHistorys: action.payload,
            };
        case "PHAN_PHOI_DE_THI_LOAD_HISTORY_ERROR":
            return {
                ...state,
                statusHistory: eReducerStatusBase.is_completed,
            };
        case "PHAN_PHOI_DE_THI_SHOW_HISTORY_MODAL":
            return {
                ...state,
                isShowHistoryModal: true,
                historySelected: action.payload,
            };
        case "PHAN_PHOI_DE_THI_CLOSE_HISTORY_MODAL":
            return {
                ...state,
                phanPhoiHistorys: [],
                historySelected: undefined,
                isShowHistoryModal: false,
            };
        default:
            return state;
    }
};
